import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalResult, RepeatFloatingFieldModalComponent as ModalComponent } from './repeat-floating-field-modal.component';

@Injectable({ providedIn: 'root' })
export class RepeatFloatingFieldModalService {
  constructor(private modalService: ModalService) {}

  open(options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, null, options);
  }
}
